import { Injectable } from '@angular/core'

import { OAuthService } from 'angular-oauth2-oidc'
import { WebSocketSubject, webSocket } from 'rxjs/webSocket'
import { environment } from 'src/environments/environment'

import { Character } from '@mmocld/data'
import { Message, SendMessage } from '@mmocld/message'

@Injectable({
  providedIn: 'root',
})
export class WsService {
  private url = environment.fdiWsUrl

  constructor(private oAuthService: OAuthService) {}

  connect(character: Character) {
    return webSocket<Message>(
      this.url +
        '?X-MMOCLD-CHARACTERID=' +
        character.characterId +
        '&Authorization=' +
        this.oAuthService.getAccessToken(),
    )
  }

  send(ws: WebSocketSubject<Message>, message: SendMessage) {
    ws.next(message)
  }
}
